import axios from "axios";

export async function fetchMemberProfileCard(userId) {
  const { data } = await axios.get("/api/user/member-profile-card", {
    params: { userId },
    withCredentials: true
  });
  return data;
}
